import type { EmailFieldUnionType } from '@api';
import { Badge, Group, HoverCard, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const VISIBLE_NAMES = 3;

export type RecipientsSummaryItemType = {
  id: string;
  name: string;
  email: string;
  emailField?: EmailFieldUnionType;
};

type RecipientsSummaryPropsType = {
  recipients: RecipientsSummaryItemType[];
};

// "Name, Name, Name +N" with the full list on hover.
export const RecipientsSummary: React.FC<RecipientsSummaryPropsType> = ({
  recipients,
}) => {
  const { t } = useTranslation();

  if (recipients.length === 0) {
    return t('NO_DATA_PLACEHOLDER');
  }

  const hiddenCount = recipients.length - VISIBLE_NAMES;
  const summary = recipients
    .slice(0, VISIBLE_NAMES)
    .map(({ name }) => name)
    .join(', ');

  return (
    <HoverCard position="bottom-start" withArrow shadow="md">
      <HoverCard.Target>
        {/* Inline, so only the names (not the whole cell) open the card. */}
        <Text span size="sm" style={{ cursor: 'default' }}>
          {hiddenCount > 0 ? `${summary} +${hiddenCount}` : summary}
        </Text>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Stack gap="xs">
          {recipients.map(({ id, emailField, name, email }) => (
            <Group key={id} gap="xs" wrap="nowrap">
              {emailField && (
                <Badge size="xs" variant="light" color="gray">
                  {emailField}
                </Badge>
              )}
              <Text size="sm">{`${name} <${email}>`}</Text>
            </Group>
          ))}
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
